import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable({ providedIn: 'root' })
export class LaDatePickerAdapter extends NativeDateAdapter {
  private readonly regex = /([0-9]{4})\/([0-9]{1,2})\/([0-9]{1,2})/;

  override format(date: Date, displayFormat: string): string {
    if (displayFormat === 'input') {
      const year = date.getFullYear();
      const month = this.padWithZero(date.getMonth() + 1);
      const day = this.padWithZero(date.getDate());
      return `${year}/${month}/${day}`;
    }
    return super.format(date, displayFormat);
  }

  override parse(value: string): Date | null {
    if (this.regex.test(value)) {
      const date = this.regex
        .exec(value)
        ?.slice(1)
        .map((v) => parseInt(v, 10));

      if (date) {
        const [year, month, day] = date;
        const newDate = new Date(year, month - 1, day);

        return this.isDateValid(newDate) ? newDate : null;
      }
      return null;
    }
    return null;
  }

  private padWithZero(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }

  private isDateValid(date: Date): boolean {
    return !isNaN(date.getTime());
  }
}
